<p-tabs [value]="0">
  <p-tablist>
    <p-tab [value]="0">Target Accounts</p-tab>
    <p-tab [value]="1">Offer Sets</p-tab>
  </p-tablist>
  <p-tabpanel [value]="0">
    <span class="search-filter">
    <p-iconField iconPosition="left">
      <p-inputIcon class="pi pi-search"></p-inputIcon>
      <input
        pInputText
        [(ngModel)]="searchValueTargetAccounts"
        class="target-account-search-bar"
        (input)="dtTarget.filterGlobal($event.target.value, 'contains')"
        placeholder="Search Target Accounts..."/>
    </p-iconField>
    </span>
    <p-table #dtTarget [value]="previewTableDataForTargetAccounts" [globalFilterFields]="['targetAccount']" [scrollable]="true" scrollHeight="300px" class="p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th>Target Accounts</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-i="rowIndex">
        <tr>
          <td>{{ row.targetAccount || '' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </p-tabpanel>
  <p-tabpanel [value]="1">
    <span class="search-filter">
      <p-iconField iconPosition="left">
        <p-inputIcon class="pi pi-search"></p-inputIcon>
        <input
          pInputText
          [(ngModel)]="searchValueOfferSets"
          (input)="dtOfferSet.filterGlobal($event.target.value, 'contains')"
          placeholder="Search Offer Sets..."/>
    </p-iconField>
    </span>
    <p-table #dtOfferSet [value]="previewTableDataForOfferSets" [globalFilterFields]="['offerSet']" [scrollable]="true" scrollHeight="300px" class="p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th>Offer Sets</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-i="rowIndex">
        <tr>
          <td>{{ row.offerSet || '' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </p-tabpanel>
</p-tabs>
@if (isSave) {
  <div class="confirm-preview-text">
    <p-divider></p-divider>
    <label>This rule will share <b>{{ appliedFilters['offerSetNames'].length }}</b> Offer Sets to
    <b>{{ this.appliedFilters['targetAccountNames'].length }}</b> account(s). Do you want to save and apply this
  rule?</label>
</div>
}
@if (isSave) {
  <div class="confirm-preview-button">
    <p-button type="button" label="Leave Preview" class="leave-preview-button" severity="secondary" (click)="this.dialogRef.close('cancel')"></p-button>
    <p-button type="button" label="Confirm" class="p-button-success" (click)="this.dialogRef.close('save')"></p-button>
  </div>
}
